import { Extension, InputRule } from '@tiptap/core'
import type { EditorState } from '@tiptap/pm/state'

type InputRange = {
    from: number
    to: number
}

function preserveHeadingMarkerSpace(state: EditorState, range: InputRange): boolean {
    const $start = state.doc.resolve(range.from)

    if ($start.parent.type.name !== 'heading') return false

    state.tr.insertText(' ', range.to)
    return true
}

export const PreserveHeadingMarkerInputRule = Extension.create({
    name: 'preserveHeadingMarkerInputRule',
    priority: 1_000,

    addInputRules() {
        return [
            new InputRule({
                find: /^(#{1,6})\s$/,
                undoable: false,
                handler: ({ state, range }) => {
                    if (!preserveHeadingMarkerSpace(state, range)) return null
                },
            }),
        ]
    },
})

export default PreserveHeadingMarkerInputRule
